export const isNull = (str) => {
  return str === "" || str === null || str === undefined;
};
